import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'notification',
	prefix: '',
	key: 'notification_id',
	fields: {
		notification_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		notification_date: Model.SCHEMA_NUMBER,
		notification_type: Model.SCHEMA_NUMBER,
		notification_title: Model.SCHEMA_TEXT,
		notification_content: Model.SCHEMA_TEXT,
		notification_data: Model.SCHEMA_JSON,
		notification_link: Model.SCHEMA_TEXT,
		notification_image: Model.SCHEMA_TEXT,
		notification_prompt: Model.SCHEMA_NUMBER
	}
})
